export default __webpack_public_path__ + "static/media/software.f5148abd.webp";